

<mat-dialog-content>
  <h2>{{'T4.Service.SelectServiceGuyDialog.lblselectserviceguys' | translate : 'Select serviceguy' }}</h2>
  <t4-container>
    <t4-data-table #listOfGuys apiMethod="Service/GetServiceGuys" headline="{{'T4.Service.SelectServiceGuyDialog.lblselectserviceguys' | translate : 'Select serviceguy' }}" matSort [allowPaging]="true" [allowExcel]="false" [allowFilter]="true" [filterFields]="['Companyname', 'Lastname', 'Firstname', 'CustomerAccount']" [autoGenerateColumns]="false">



      <ng-container matColumnDef="CustomerAccount">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:55px;"></mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="serviceguySelected(row)" style="max-width: 400px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ row.CustomerAccount}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Companyname">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 400px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="serviceguySelected(row)" style="max-width: 400px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ row.Companyname}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Lastname">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="serviceguySelected(row)" style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ row.Lastname}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Firstname">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" (click)="serviceguySelected(row)" style="max-width: 300px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          {{ row.Firstname}}
        </mat-cell>
      </ng-container>

    </t4-data-table>
  </t4-container>
</mat-dialog-content>
